export default "__VITE_ASSET__9d477e8a__"